
<button class="btn btn-lg bg-blue text-white float-right ml-3"  (click)="filterNavStatus = true">
    <i class="align-middle fas fa-filter"></i>
</button>

<table class="neu-table table table-striped neu-table w-auto  table-responsive"
 datatable
[dtOptions]="dtOptions">
</table>

<!-- Filter right sidenav -->
<app-case-detail-expenses-filter (onApplyFilter)="applyFilter($event)" 
 (resetFilters)="onResetFilters()"  [filterStatusParent]="filterNavStatus"  (closeBtnFilterStatus)="closeFilterEvent($event)"></app-case-detail-expenses-filter>


